@import '../styles/_vars.css';

.sectionCards {
  padding-top: 4.5em;
  padding-bottom: 3.4em;
}

.sectionCards h2 {
  text-align: center;
  margin-bottom: 1.2em;
}

.cards {
  display: flex;
  flex-direction: column;
  gap: 1.2em;
}

.card {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 1em;
  flex: 1;
}

.cardImg {
  width: 110px;
  height: 110px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.card h4 {
  margin-top: 1em;
  margin-bottom: .5em;
}

@media screen and (min-width: 770px) {
  .cards {
    flex-direction: row;
  }
}
